import { Changelog } from "components/changelog"
import { SEO } from "components/core/seo"
import { BASE_URL } from "lib/utils"
import React from "react"

const ChangelogPage = () => (
  <>
    <SEO
      title="Changelog - What's new?"
      description="Additions, improvements and fixes related to the Frontend Toolkit dashboard."
      ogImage={{
        title: "Changelog",
        url: `${BASE_URL}/changelog`,
      }}
    />
    <Changelog />
  </>
)

export default ChangelogPage
